// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"music-2"},"nodeName":"g","children":[{"attributes":{"id":"fill1","cx":9,"cy":18,"r":3,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M12 18V4H18M12 18C12 19.6569 10.6569 21 9 21C7.34315 21 6 19.6569 6 18C6 16.3431 7.34315 15 9 15C10.6569 15 12 16.3431 12 18Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-music-2')
export default class Music2Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'music-2',
    }
  }
}
